// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type SuccessResponse } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useTranscriptAndAnalyse(): (
  kontaktaufnahmeId: string
) => Promise<SuccessResponse> {
  const getAPI = useGetApi();
  return useCallback(
    async (kontaktaufnahmeId) =>
      (await getAPI()).kontaktaufnahme.transcriptAndAnalyse({
        kontaktaufnahmeId,
      }),
    [getAPI]
  );
}
